import React, { useEffect, useState } from 'react';
import { MenuIcon, XIcon } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'About',
    href: '#about'
  }, {
    name: 'Approach',
    href: '#approach'
  }, {
    name: 'Services',
    href: '#services'
  }, {
    name: 'Testimonials',
    href: '#testimonials'
  }];
  return <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-charcoal-950/95 backdrop-blur-md py-4 shadow-lg' : 'bg-transparent py-6'}`} data-id="element-146">
      <div className="max-w-7xl mx-auto px-6 md:px-12 flex items-center justify-between" data-id="element-147">
        <a href="#" className="text-2xl font-bold text-offwhite-50 tracking-tight" data-id="element-148">
          McLean <span className="text-amber-500" data-id="element-149">PT</span>
        </a>

        {/* Desktop Nav */}
        <div className="hidden md:flex items-center space-x-8" data-id="element-150">
          {navLinks.map(link => <a key={link.name} href={link.href} className="text-offwhite-100 hover:text-amber-500 transition-colors text-sm font-medium" data-id="element-151">
              {link.name}
            </a>)}
          <a href="https://calendly.com/dylanmclean-mcleanphysicaltherapy/consult-call" target="_blank" rel="noopener noreferrer" className="bg-amber-500 hover:bg-amber-400 text-charcoal-950 px-6 py-2.5 rounded-full font-semibold transition-all transform hover:scale-105" data-id="element-152">
            Book a Consult
          </a>
        </div>

        {/* Mobile Menu Toggle */}
        <button className="md:hidden text-offwhite-50" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} data-id="element-153">
          {isMobileMenuOpen ? <XIcon size={28} data-id="element-154" /> : <MenuIcon size={28} data-id="element-155" />}
        </button>
      </div>

      {/* Mobile Nav */}
      <AnimatePresence data-id="element-156">
        {isMobileMenuOpen && <motion.div initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} className="md:hidden bg-charcoal-900 border-t border-charcoal-800" data-id="element-157">
            <div className="flex flex-col px-6 py-4 space-y-4" data-id="element-158">
              {navLinks.map(link => <a key={link.name} href={link.href} onClick={() => setIsMobileMenuOpen(false)} className="text-offwhite-100 hover:text-amber-500 text-lg font-medium py-2" data-id="element-159">
                  {link.name}
                </a>)}
              <a href="https://calendly.com/dylanmclean-mcleanphysicaltherapy/consult-call" target="_blank" rel="noopener noreferrer" className="bg-amber-500 text-charcoal-950 px-6 py-3 rounded-lg font-semibold text-center mt-4" data-id="element-160">
                Book a Consult
              </a>
            </div>
          </motion.div>}
      </AnimatePresence>
    </nav>;
}